<template>
    <div class="fixed-bottom-bar">
        <b-row class="d-flex justify-content-around">
            <div>
                <p class="d-inline-block m-0 p-0">
                    <span class="font-weight-bolder mr-2">Forderungen Total:</span>
                    <span
                        v-html="currencyColored(sums.total)"
                    ></span>
                </p>
            </div>
            <div>
                <p class="d-inline-block m-0 p-0">
                    <span class="font-weight-bolder mr-2">Einnahmen aus Forderungen:</span>
                    <span
                        v-html="currencyColored(sums.paid)"
                    ></span>
                </p>
            </div>
            <div>
                <p class="d-inline-block m-0 p-0">
                    <span class="font-weight-bolder mr-2">Offene Beträge:</span>
                    <span
                        v-html="currencyColored(sums.open)"
                    ></span>
                </p>
            </div>
        </b-row>
    </div>
</template>

<script>
import './FixedBottomBar_OP.scss';
import Currency from "@/mixins/Currency/Currency";
import { ApiFactory } from "@/api/ApiFactory";
import CommonView from "@/mixins/CommonView/CommonView";

export default {
    name: "FixedBottomBar_OP",
    props: ['sums'],
    mixins: [CommonView, Currency],
    data() {
        return {
            prefetch: false
        }
    }
}
</script>

<style scoped>

</style>